import { useEffect, useState } from "react";
import {
  EXPERIMENT_PREVIEW_CHANGE_EVENT,
  getExperimentPreviewState,
} from "../services/experiments/previewMode";

export default function useExperimentPreviewState() {
  const [state, setState] = useState(() => getExperimentPreviewState());

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const syncState = () => {
      setState(getExperimentPreviewState());
    };

    window.addEventListener(EXPERIMENT_PREVIEW_CHANGE_EVENT, syncState);
    window.addEventListener("popstate", syncState);

    return () => {
      window.removeEventListener(EXPERIMENT_PREVIEW_CHANGE_EVENT, syncState);
      window.removeEventListener("popstate", syncState);
    };
  }, []);

  return state;
}
